// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bic_a bic_j bic_q bic_sv bic_sw bic_w"};